
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/services/awsapprunner/thanks",
      function () {
        return require("private-next-pages/services/awsapprunner/thanks.tsx");
      }
    ]);
  